import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductDetailsUiStateService } from '../product-details-ui-state.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss']
})
export class ProductDescriptionComponent {
  @Input() description: string;
  @Input() finalPrice: number;

  constructor(private _pUiService: ProductDetailsUiStateService,
    private _route: ActivatedRoute){
    
  }
  
  continueOrder(step: number): void{
    this._pUiService.continueOrder(step, this._route.snapshot.params.i);
  }
}
